import * as React from 'react';
import { themr } from 'react-css-themr';
import * as scrollToElement from 'scroll-to-element';
import slugify from '../utils/slugify';
function extractHeadings(content) {
    const result = [];
    content
        .split(/\n/g)
        .filter(item => item.trim().startsWith('#'))
        .forEach(item => {
        const tmp = item.match(/#/g);
        if (tmp) {
            result.push({
                value: item.replace(/#/g, '').trim(),
                depth: tmp && tmp.length,
            });
        }
    });
    return result;
}
function DumpToc({ source, offset = -80, duration = 1500, shift = 2, ease, theme = {}, onClick, }) {
    const headings = extractHeadings(source || '');
    return (React.createElement("div", { className: theme.root }, headings.map((x, idx) => {
        const H = `h${x.depth + shift}`;
        const slug = slugify(x.value);
        return (React.createElement(H, { className: theme.heading, key: idx },
            React.createElement("a", { className: theme.link, style: { paddingLeft: `${(x.depth - shift) * 0.6}rem` }, href: `#${slug}`, onClick: e => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (onClick) {
                        onClick();
                    }
                    const element = document.getElementById(slug);
                    if (element) {
                        scrollToElement(element, {
                            offset,
                            ease,
                            duration,
                        });
                    }
                } }, x.value)));
    })));
}
export default themr('Toc', {}, {
    composeTheme: 'softly',
})(DumpToc);
//# sourceMappingURL=index.js.map